import ClaimPodcastOwnershipModal from './ClaimPodcastOwnershipModal';

export default ClaimPodcastOwnershipModal;
